import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropdown-add",
  "use": "dropdown-add-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"dropdown-add\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.364 8.862a.75.75 0 00-1.5 0v2.195H9.669a.75.75 0 000 1.5h2.195v2.194a.75.75 0 001.5 0v-2.194h2.194a.75.75 0 000-1.5h-2.194V8.862z\" fill=\"currentColor\" /><path d=\"M1 8h6M1 4h12M1 12h6\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol